// File validation utilities for document upload

export const ALLOWED_EXTENSIONS = ['txt', 'pdf', 'docx', 'rtf', 'doc', 'pages'] as const

export type AllowedExtension = (typeof ALLOWED_EXTENSIONS)[number]

export const MAX_FILE_SIZE = 10 * 1024 * 1024 // 10MB

export function getFileExtension(filename: string): string {
  const parts = filename.toLowerCase().split('.')
  return parts.length > 1 ? parts[parts.length - 1] : ''
}

export function validateFile(file: File): { valid: boolean; error?: string } {
  // Check file size
  if (file.size > MAX_FILE_SIZE) {
    return {
      valid: false,
      error: `File is too large. Maximum size is ${MAX_FILE_SIZE / (1024 * 1024)}MB.`,
    }
  }

  // Check file size is not zero
  if (file.size === 0) {
    return {
      valid: false,
      error: 'File is empty.',
    }
  }

  // Check file extension
  const ext = getFileExtension(file.name)
  if (!ext) {
    return {
      valid: false,
      error: 'File has no extension.',
    }
  }

  if (!ALLOWED_EXTENSIONS.includes(ext as AllowedExtension)) {
    return {
      valid: false,
      error: `Unsupported file format: .${ext}. Allowed formats: ${ALLOWED_EXTENSIONS.map(e => `.${e}`).join(', ')}`,
    }
  }

  return { valid: true }
}
